import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-error-modal',
  templateUrl: './error-modal.component.html',
  styleUrls: ['./error-modal.component.scss']
})
export class ErrorModalComponent {
  @Output() closePressed: EventEmitter<boolean> = new EventEmitter();
  
  close() {
    this.closePressed.emit(true);

  }
}
